import * as React from 'react';
import ManageContract from '../../components/contract/ManageContract';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function Contract() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])

  return (
    <ManageContract></ManageContract>
  );
}